import { isFolder } from 'reactApp/modules/file/utils';
import { ApiFolderResponse, ApiFolderResponseFile } from 'reactApp/modules/home/home.types';

export const isApiFolderType = (item: ApiFolderResponse | ApiFolderResponseFile): item is ApiFolderResponse => isFolder(item);
